var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.user)?_c('navigation-bar',{attrs:{"user":_vm.user}}):_vm._e(),_c('router-view'),(_vm.user)?_c('footer-bar',{attrs:{"user":_vm.user}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }